export default __webpack_public_path__ + "static/media/profile-bg.3038c95d.png";